import React from 'react';
import Maybe from 'react-maybe';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import cx from 'classnames';
import { Button, Icon, Modal, Media } from '@ers/ui';
import { useModal } from '@ers/hooks/';
import { sendAddApplicationClickedEvent } from '@ers/root/App.actions';
import WizardContextContainer, { useWizard } from '../../context/WizardContextContainer';
import Step1 from './Step1';
import Step2 from './Step2';

const CurrentStep = ({ onClick }) => {
    const { currentStep } = useWizard();
    switch (currentStep) {
        case 0:
            return (
                <Step1 onClick={onClick} />
            );
        case 1:
            return (
                <Step2 onClick={onClick} />
            );
        default:
            return null;
    }
};

CurrentStep.propTypes = {
    onClick: PropTypes.func.isRequired,
};

const CurrentTitle = () => {
    const { currentStep } = useWizard();

    switch (currentStep) {
        case 0:
            return 'Dodaj aplikację';
        case 1:
            return 'Funkcja w przygotowaniu';
        default:
            return null;
    }
};

const AddApplicationSmokeTest = ({ className, requireMobileView }) => {
    const [isVisible, openModal, hideModal] = useModal(false);
    const dispatch = useDispatch();

    const handleClick = () => {
        dispatch(sendAddApplicationClickedEvent());
        openModal();
    };
    return (
        <>
            <Maybe
                of={requireMobileView}
                either={(
                    <>
                        <Media phone>
                            <Button.Primary onClick={handleClick} className={cx('btn--ico', className)}>
                                <Icon name="add" />
                            </Button.Primary>
                        </Media>
                        <Media
                            tabletPortrait
                            tabletLandscape
                            desktop
                            fullHD
                        >
                            <Button.Primary onClick={handleClick} className={className}>
                                <Icon name="add" />
                                Dodaj aplikację
                            </Button.Primary>
                        </Media>
                    </>
                )}
                orElse={(
                    <Button.Primary onClick={handleClick} className={className}>
                        <Icon name="add" />
                        Dodaj aplikację
                    </Button.Primary>
                )}
            />
            {isVisible && (
                <WizardContextContainer>
                    <Modal close={hideModal} title={<CurrentTitle />}>
                        <CurrentStep onClick={hideModal} />
                    </Modal>
                </WizardContextContainer>
            )}
        </>
    );
};

AddApplicationSmokeTest.propTypes = {
    className: PropTypes.string,
    requireMobileView: PropTypes.bool
};

AddApplicationSmokeTest.defaultProps = {
    className: null,
    requireMobileView: false
};

export default AddApplicationSmokeTest;